export const DATE_FORMAT = "YYYY/MM/DD";
export const DATE_TIME_FORMAT_WITH_SECONDS = "YYYY/MM/DD HH:mm:ss";
export const DATE_TIME_FORMAT = "YYYY/MM/DD HH:mm";
export const ISO_FORMAT = "YYYY-MM-DDTHH:mm:ss[Z]";
export const DAY_FORMAT = "DD";
export const MONTH_FORMAT = "MM";
export const YEAR_FORMAT = "YYYY";
export const WEEKDAY_FORMAT = "dd";
export const YEAR_MONTH_FORMAT = "YYYY/MM";
export const YEAR_MONTH_STR_FORMAT = "YYYY年MM月";
export const YEAR_MONTH_DAY_STR_FORMAT = "YYYY年MM月DD日";
export const DATE_FORMAT_FOR_API = "YYYY-MM-DD";
export const MONTH_DATE_FORMAT_WITH_TIMES = "MM/DD HH:mm";
export const DATE_FORMAT_FOR_FILENAME = "YYMMDD";
